import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import ClinicalServices from "../ones/ClinicalServices";
import Clinical from "../ones/Clinical";
import Maternal from "../ones/Maternal";
import Diagnosis from "../ones/Diagnosis";
import Pharmacy from "../ones/Pharmacy";
import Specialized from "../ones/Specialized";
import Wellness from "../ones/Wellness";
import Telehealth from "../ones/Telehealth";
import ServicesLanding from "../views/ServicesLanding";

export default function Services() {
  const appContext = useContext(AppContext);
  const [view, setView] = useState(null);

  async function init() {
    // run initializations here
  }

  function getView() {
    if (
      !appContext.navSubItem && 
      !appContext.navExtraItem && 
      !appContext.navMoreItem
    ) {
      return <ServicesLanding />;
    } else if (
      appContext.navSubItem === 'clinical' && 
      !appContext.navExtraItem && 
      !appContext.navMoreItem
    ) {
      return <Clinical />;
    } else if (
      appContext.navSubItem === 'maternal' && 
      !appContext.navExtraItem && 
      !appContext.navMoreItem
    ) {
      return <Maternal />;
    } else if (
      appContext.navSubItem === 'pharmacy' && 
      !appContext.navExtraItem && 
      !appContext.navMoreItem
    ) {
      return <Pharmacy />;
    } else if (
      appContext.navSubItem === 'diagnosis' && 
      !appContext.navExtraItem && 
      !appContext.navMoreItem
    ) {
      return <Diagnosis />;
    } else if (
      appContext.navSubItem === 'specialized' && 
      !appContext.navExtraItem && 
      !appContext.navMoreItem
    ) {
      return <Specialized />;
    } else if (
      appContext.navSubItem === 'wellness' && 
      !appContext.navExtraItem && 
      !appContext.navMoreItem
    ) {
      return <Wellness />;
    } else if (
      appContext.navSubItem === 'telehealth' && 
      !appContext.navExtraItem && 
      !appContext.navMoreItem
    ) {
      return <Telehealth />;
    }

      return <ServicesLanding />;
    }

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    const nextView = getView();
    if (nextView) {
      setView(nextView);
    }
  }, [appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem]);

  return view;
}
